import { ref } from 'vue'

// Görüntülenen öneri verisi
export const currentSuggestion = ref(null)

// Yükleme durumu
export const isLoading = ref(false)

// Hata durumu
export const error = ref(null)
